import { changeZIPCodeURL, quotePageCartName, quotePageCartURL, quotePageName, quotePageURL } from "QuotePage/urls";

import type { CatalogEntry, ConciergeActions, NavTarget } from "../actions";

// Maps a backend feature id to a button label and click behavior. No entry → no button.

export type DestinationKey = "quote_page" | "cart" | "change_zip" | "support";

const SUPPORT_URL = "https://support.simplyinsured.com/";

export const destinations: Record<DestinationKey, () => NavTarget> = {
  quote_page: () => ({ spaPath: quotePageName(undefined), absoluteUrl: quotePageURL(undefined, undefined) }),
  cart: () => ({ spaPath: quotePageCartName(undefined), absoluteUrl: quotePageCartURL(undefined) }),
  change_zip: () => ({ spaPath: changeZIPCodeURL(), absoluteUrl: changeZIPCodeURL({ relative: false }) }),
  // No in-SPA route, so it always full-loads.
  support: () => ({ spaPath: SUPPORT_URL, absoluteUrl: SUPPORT_URL }),
};

// Keyed by backend feature id.
export const catalog: Record<string, CatalogEntry<DestinationKey>> = {
  shop_all_plans: { label: "Go to Medical Plans", target: "quote_page", tab: "shop_all_plans" },
  recommended_plans: { label: "Go to Recommended Plans", target: "quote_page", tab: "recommended" },
  recommendation_survey: { label: "Go to Recommended Plans to take the survey", target: "quote_page", tab: "recommended" },
  multiple_plans: { label: "Go to Plan Packages", target: "quote_page", tab: "multiple_plans" },
  favorite_plans: { label: "Go to Favorites", target: "quote_page", tab: "favorite_plans" },
  dental_plans: { label: "Go to Dental Plans", target: "quote_page", tab: "dental_plans" },
  limited_value_plans: { label: "Go to MEC Plans", target: "quote_page", tab: "limited_value_plans" },
  enter_ages: { label: "Go to Employee Profile", target: "quote_page" },
  support: { label: "Open Support Center", target: "support" },
  // Open the full answer in a modal instead of navigating.
  coverage_start: { label: "More on coverage start dates", faqModal: true },
  employee_enrollment: { label: "More on employee enrollment", faqModal: true },
  application_process: { label: "More on the application process", faqModal: true },
  doctor_search: { label: "More on finding your doctor", faqModal: true },
  plan_pricing: { label: "More on how pricing is set", faqModal: true },
  plan_cost_variance: { label: "More on why prices differ", faqModal: true },
  schedule_a_consult: { label: "Open the Quote Page to schedule a consult", target: "quote_page" },
  compare_plans: { label: "Go to Medical Plans to start comparing", target: "quote_page", tab: "shop_all_plans" },
  add_dental_plan: { label: "Go to Quote Page to add a dental plan", target: "quote_page" },
  add_vision_plan: { label: "Go to Quote Page to add a vision plan", target: "quote_page" },
  change_zip_code: { label: "Go to Quote Page to change zip code", target: "change_zip" },
  medical_plan_filters: { label: "Go to Medical Plans", target: "quote_page", tab: "shop_all_plans" },
  dental_plan_filters: { label: "Go to Dental Plans", target: "quote_page", tab: "dental_plans" },
  medical_plan_card: { label: "Go to Medical Plans", target: "quote_page" },
  plan_details_page: { label: "Go to Medical Plans", target: "quote_page" },
  cost_breakdown: { label: "Go to Medical Plans", target: "quote_page" },
  cart: { label: "Go to Cart", target: "cart" },
  // Omitted (no button): live_chat, sbc, add_plan.
};

// The bundle GatedConciergeChat consumes for this domain.
export const quotingActions: ConciergeActions<DestinationKey> = {
  domain: "quoting",
  spaRoutes: ["/select-plan", "/compare-plans"],
  catalog,
  destinations,
};
